import { Button } from 'antd';
import type { DriverDocumentListItem, DriverDocumentType } from './drivers.api';

interface DriverDocumentRowProps {
  documentType: DriverDocumentType;
  attached: DriverDocumentListItem | undefined;
  canManage: boolean;
  onDownload: (documentTypeCode: string) => void;
  onUpload: (documentType: DriverDocumentType) => void;
}

export function DriverDocumentRow({ documentType, attached, canManage, onDownload, onUpload }: DriverDocumentRowProps) {
  return (
    <li className="flex items-center justify-between gap-3 rounded-lg border border-line bg-surface px-4 py-3">
      <div>
        <p className="font-medium text-fg">{documentType.name}</p>
        <p className="text-sm text-muted">
          {attached
            ? `Uploaded by ${attached.uploadedBy?.name ?? 'an office user'}${attached.expiresAt ? ` · Expires ${attached.expiresAt}` : ''}`
            : 'Not attached'}
        </p>
      </div>
      <div className="flex items-center gap-2">
        {attached && (
          <Button size="small" onClick={() => onDownload(documentType.code)}>
            Download
          </Button>
        )}
        {canManage && (
          <Button size="small" onClick={() => onUpload(documentType)}>
            {attached ? 'Replace' : 'Upload'}
          </Button>
        )}
      </div>
    </li>
  );
}
